module.exports = __webpack_public_path__ + "static/media/home-banner.23a88cbe.jpg";